module.exports = __webpack_public_path__ + "img/option1.314c3ee5.png";